import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { sortBy } from 'lodash-es';
import { RadioButtonWithLabel, Typography, useOverlayContext } from 'seagull';
import { filterCustomerWorkspaces } from '~/client-flow/clientOb/WelcomeStep/welcomeStepUtils';
import { ResponsiveModal } from '~/client-flow/components/ResponsiveModal';
import { useResponsive } from '~/client-flow/contexts';
import { useLocaleKeys } from '~/i18n';
import { sendErrReport } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import styles from './SwitchProposalBusiness.module.scss';
export function SwitchProposalBusiness(props) {
    const { relationship, onClose } = props;
    const { t: texts } = useLocaleKeys('clientFlow.switchBusiness');
    const { t: commonTexts } = useLocaleKeys('common');
    const relationshipId = relationship.id;
    const { api, logBI } = useStoreActions();
    const email = useStore((state)=>{
        var _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.email();
    });
    const worksAt = useStore(selectors.user.business);
    const workspaces = useStore(selectors.user.workspaces);
    const { isDesktop } = useResponsive();
    const overlayContext = useOverlayContext();
    const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    const clientWorkspaces = sortBy(filterCustomerWorkspaces(workspaces !== null && workspaces !== void 0 ? workspaces : [], relationship.vendor.id), (workspace)=>workspace.name());
    const onApproveBusinessChange = async ()=>{
        const shouldSwitchBusiness = selectedWorkspaceId && selectedWorkspaceId !== (worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
        if (shouldSwitchBusiness) {
            logBI(10835, {
                companyName: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name,
                email
            });
            try {
                await api.relationship.associateCustomer(relationshipId, selectedWorkspaceId);
                onClose(selectedWorkspaceId);
            } catch (err) {
                sendErrReport(err);
                overlayContext.showErrorToast(commonTexts.toasts.failedToAssignProposal(), 'switch-business-failure-toast');
            }
        } else {
            onClose();
        }
    };
    return /*#__PURE__*/ _jsxs(ResponsiveModal, {
        testId: "switch-proposal-business-modal",
        title: texts.title(),
        mobileTitle: texts.mobileTitle(),
        onClose: ()=>onClose(),
        isDesktop: isDesktop,
        primaryButtonLabel: commonTexts.buttons.assignProposal(),
        onPrimaryButtonClick: onApproveBusinessChange,
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: ()=>onClose(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                as: "span",
                children: texts.currentlyAssigned()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                weight: "bold",
                as: "span",
                testId: "current-company",
                children: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name
            }),
            /*#__PURE__*/ _jsx(Typography, {
                as: "span",
                children: texts.newBusinessCreated()
            }),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx(Typography, {
                children: texts.selectBusinessInfo()
            }),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx(Typography, {
                skin: "secondary",
                children: texts.selectBusiness()
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.businessOptionsWrapper,
                children: clientWorkspaces === null || clientWorkspaces === void 0 ? void 0 : clientWorkspaces.map((workspace)=>{
                    return /*#__PURE__*/ _jsx(RadioButtonWithLabel, {
                        label: workspace.name(),
                        testId: "business-option",
                        checked: selectedWorkspaceId === workspace.id(),
                        onChange: ()=>setSelectedWorkspaceId(workspace.id())
                    }, workspace.id());
                })
            })
        ]
    });
}
